var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H22C27.5228 0 32 4.47715 32 10V22C32 27.5228 27.5228 32 22 32H10C4.47715 32 0 27.5228 0 22V10Z",
    fill: "#ECFDF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.6667V22",
    stroke: "#009966",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C9.82323 20 9.65366 19.9298 9.52864 19.8047C9.40361 19.6797 9.33337 19.5101 9.33337 19.3333V10.6667C9.33337 10.4899 9.40361 10.3203 9.52864 10.1953C9.65366 10.0702 9.82323 10 10 10H13.3334C14.0406 10 14.7189 10.281 15.219 10.781C15.7191 11.2811 16 11.9594 16 12.6667C16 11.9594 16.281 11.2811 16.7811 10.781C17.2812 10.281 17.9595 10 18.6667 10H22C22.1769 10 22.3464 10.0702 22.4714 10.1953C22.5965 10.3203 22.6667 10.4899 22.6667 10.6667V19.3333C22.6667 19.5101 22.5965 19.6797 22.4714 19.8047C22.3464 19.9298 22.1769 20 22 20H18C17.4696 20 16.9609 20.2107 16.5858 20.5858C16.2108 20.9609 16 21.4696 16 22C16 21.4696 15.7893 20.9609 15.4143 20.5858C15.0392 20.2107 14.5305 20 14 20H10Z",
    stroke: "#009966",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReading);
export default __webpack_public_path__ + "static/media/ic_reading.a6480f5cde40da616aed2c1cd4320bed.svg";
export { ForwardRef as ReactComponent };